// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__3fWhW","filter":"styles_filter__3lLNE","label":"styles_label__31dEe"};